"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* tslint:disable */

/*
query ArtworkDetailsQuery(
  $artworkID: String!
) {
  artwork(id: $artworkID) {
    ...ArtworkDetails_artwork
    __id
  }
}

fragment ArtworkDetails_artwork on Artwork {
  ...ArtworkDetailsAboutTheWorkFromArtsy_artwork
  ...ArtworkDetailsAboutTheWorkFromPartner_artwork
  ...ArtworkDetailsAdditionalInfo_artwork
  ...ArtworkDetailsArticles_artwork
  articles(size: 10) {
    id
    __id
  }
  literature(format: HTML)
  exhibition_history(format: HTML)
  provenance(format: HTML)
  __id
}

fragment ArtworkDetailsAboutTheWorkFromArtsy_artwork on Artwork {
  description(format: HTML)
  __id
}

fragment ArtworkDetailsAboutTheWorkFromPartner_artwork on Artwork {
  additional_information(format: HTML)
  sale {
    isBenefit
    isGalleryAuction
    __id
  }
  partner {
    _id
    id
    type
    href
    name
    initials
    locations {
      city
      __id
    }
    is_default_profile_public
    profile {
      ...FollowProfileButton_profile
      id
      icon {
        url(version: "square140")
        __id: id
      }
      __id
    }
    __id
  }
  __id
}

fragment ArtworkDetailsAdditionalInfo_artwork on Artwork {
  series
  publisher
  manufacturer
  image_rights
  framed {
    label
    details
  }
  signatureInfo {
    label
    details
  }
  conditionDescription {
    label
    details
  }
  certificateOfAuthenticity {
    label
    details
  }
  __id
}

fragment ArtworkDetailsArticles_artwork on Artwork {
  articles(size: 10) {
    author {
      name
      __id
    }
    href
    published_at(format: "MMM Do, YYYY")
    thumbnail_image {
      resized(width: 300) {
        url
      }
      __id: id
    }
    thumbnail_title
    __id
  }
  __id
}

fragment FollowProfileButton_profile on Profile {
  __id
  id
  is_followed
}
*/
var node = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "artworkID",
    "type": "String!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "id",
    "variableName": "artworkID",
    "type": "String!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__id",
    "args": null,
    "storageKey": null
  },
      v3 = [{
    "kind": "Literal",
    "name": "format",
    "value": "HTML",
    "type": "Format"
  }],
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "href",
    "args": null,
    "storageKey": null
  },
      v6 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v7 = {
    "kind": "ScalarField",
    "alias": "__id",
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v8 = [{
    "kind": "ScalarField",
    "alias": null,
    "name": "label",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "details",
    "args": null,
    "storageKey": null
  }];
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "ArtworkDetailsQuery",
    "id": null,
    "text": "query ArtworkDetailsQuery(\n  $artworkID: String!\n) {\n  artwork(id: $artworkID) {\n    ...ArtworkDetails_artwork\n    __id\n  }\n}\n\nfragment ArtworkDetails_artwork on Artwork {\n  ...ArtworkDetailsAboutTheWorkFromArtsy_artwork\n  ...ArtworkDetailsAboutTheWorkFromPartner_artwork\n  ...ArtworkDetailsAdditionalInfo_artwork\n  ...ArtworkDetailsArticles_artwork\n  articles(size: 10) {\n    id\n    __id\n  }\n  literature(format: HTML)\n  exhibition_history(format: HTML)\n  provenance(format: HTML)\n  __id\n}\n\nfragment ArtworkDetailsAboutTheWorkFromArtsy_artwork on Artwork {\n  description(format: HTML)\n  __id\n}\n\nfragment ArtworkDetailsAboutTheWorkFromPartner_artwork on Artwork {\n  additional_information(format: HTML)\n  sale {\n    isBenefit\n    isGalleryAuction\n    __id\n  }\n  partner {\n    _id\n    id\n    type\n    href\n    name\n    initials\n    locations {\n      city\n      __id\n    }\n    is_default_profile_public\n    profile {\n      ...FollowProfileButton_profile\n      id\n      icon {\n        url(version: \"square140\")\n        __id: id\n      }\n      __id\n    }\n    __id\n  }\n  __id\n}\n\nfragment ArtworkDetailsAdditionalInfo_artwork on Artwork {\n  series\n  publisher\n  manufacturer\n  image_rights\n  framed {\n    label\n    details\n  }\n  signatureInfo {\n    label\n    details\n  }\n  conditionDescription {\n    label\n    details\n  }\n  certificateOfAuthenticity {\n    label\n    details\n  }\n  __id\n}\n\nfragment ArtworkDetailsArticles_artwork on Artwork {\n  articles(size: 10) {\n    author {\n      name\n      __id\n    }\n    href\n    published_at(format: \"MMM Do, YYYY\")\n    thumbnail_image {\n      resized(width: 300) {\n        url\n      }\n      __id: id\n    }\n    thumbnail_title\n    __id\n  }\n  __id\n}\n\nfragment FollowProfileButton_profile on Profile {\n  __id\n  id\n  is_followed\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "ArtworkDetailsQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "artwork",
        "storageKey": null,
        "args": v1,
        "concreteType": "Artwork",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "ArtworkDetails_artwork",
          "args": null
        }, v2]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "ArtworkDetailsQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "artwork",
        "storageKey": null,
        "args": v1,
        "concreteType": "Artwork",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "image_rights",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": v3,
          "storageKey": "description(format:\"HTML\")"
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "additional_information",
          "args": v3,
          "storageKey": "additional_information(format:\"HTML\")"
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "sale",
          "storageKey": null,
          "args": null,
          "concreteType": "Sale",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "isBenefit",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "isGalleryAuction",
            "args": null,
            "storageKey": null
          }, v2]
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "partner",
          "storageKey": null,
          "args": null,
          "concreteType": "Partner",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "_id",
            "args": null,
            "storageKey": null
          }, v4, {
            "kind": "ScalarField",
            "alias": null,
            "name": "type",
            "args": null,
            "storageKey": null
          }, v5, v6, {
            "kind": "ScalarField",
            "alias": null,
            "name": "initials",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "locations",
            "storageKey": null,
            "args": null,
            "concreteType": "Location",
            "plural": true,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "name": "city",
              "args": null,
              "storageKey": null
            }, v2]
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "is_default_profile_public",
            "args": null,
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "profile",
            "storageKey": null,
            "args": null,
            "concreteType": "Profile",
            "plural": false,
            "selections": [v2, v4, {
              "kind": "ScalarField",
              "alias": null,
              "name": "is_followed",
              "args": null,
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "name": "icon",
              "storageKey": null,
              "args": null,
              "concreteType": "Image",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "url",
                "args": [{
                  "kind": "Literal",
                  "name": "version",
                  "value": "square140",
                  "type": "[String]"
                }],
                "storageKey": "url(version:\"square140\")"
              }, v7]
            }]
          }, v2]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "series",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "publisher",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "manufacturer",
          "args": null,
          "storageKey": null
        }, v2, {
          "kind": "LinkedField",
          "alias": null,
          "name": "framed",
          "storageKey": null,
          "args": null,
          "concreteType": "ArtworkInfoRow",
          "plural": false,
          "selections": v8
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "signatureInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "ArtworkInfoRow",
          "plural": false,
          "selections": v8
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "conditionDescription",
          "storageKey": null,
          "args": null,
          "concreteType": "ArtworkInfoRow",
          "plural": false,
          "selections": v8
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "certificateOfAuthenticity",
          "storageKey": null,
          "args": null,
          "concreteType": "ArtworkInfoRow",
          "plural": false,
          "selections": v8
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "articles",
          "storageKey": "articles(size:10)",
          "args": [{
            "kind": "Literal",
            "name": "size",
            "value": 10,
            "type": "Int"
          }],
          "concreteType": "Article",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "author",
            "storageKey": null,
            "args": null,
            "concreteType": "Author",
            "plural": false,
            "selections": [v6, v2]
          }, v5, {
            "kind": "ScalarField",
            "alias": null,
            "name": "published_at",
            "args": [{
              "kind": "Literal",
              "name": "format",
              "value": "MMM Do, YYYY",
              "type": "String"
            }],
            "storageKey": "published_at(format:\"MMM Do, YYYY\")"
          }, {
            "kind": "LinkedField",
            "alias": null,
            "name": "thumbnail_image",
            "storageKey": null,
            "args": null,
            "concreteType": "Image",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "resized",
              "storageKey": "resized(width:300)",
              "args": [{
                "kind": "Literal",
                "name": "width",
                "value": 300,
                "type": "Int"
              }],
              "concreteType": "ResizedImageUrl",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "name": "url",
                "args": null,
                "storageKey": null
              }]
            }, v7]
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "thumbnail_title",
            "args": null,
            "storageKey": null
          }, v2, v4]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "literature",
          "args": v3,
          "storageKey": "literature(format:\"HTML\")"
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "exhibition_history",
          "args": v3,
          "storageKey": "exhibition_history(format:\"HTML\")"
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "provenance",
          "args": v3,
          "storageKey": "provenance(format:\"HTML\")"
        }]
      }]
    }
  };
}();

node.hash = '17f9b5d03a9a73a10bf17f4ba27e4156';
var _default = node;
exports.default = _default;
//# sourceMappingURL=ArtworkDetailsQuery.graphql.js.map